export enum ActionTypes {
  COMPANY_PREPARE_WIZARD = "COMPANY_PREPARE_WIZARD",
  COMPANY_FETCH_COMPANY = "COMPANY_FETCH_COMPANY"
}
